import { SEARCH } from "../constants/ActionTypes";

const initialState = {
  search: [],
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH: {
      return {
        ...state,
        search: action.payload,
      };
    }

    default:
      return state;
  }
};

export default rootReducer;
